// i18nOwl-ignore [errorAccessDenied.title, errorAccessDenied.description, errorDefault.title, errorDefault.description, errorExternalIdNotUnique.title, errorExternalIdNotUnique.description, errorInsufficientPermissions.title, errorInsufficientPermissions.description]
import Title from '@cohort/components-xps/components/Title';
import Button from '@cohort/wallet/components/button/Button';
import {BaseModal, DrawerModal} from '@cohort/wallet/components/modals/Modal';
import {useScreenSize} from '@cohort/wallet/hooks/useScreenSize';
import {useTranslation} from 'react-i18next';

type OAuthErrorModalProps = {
  title?: string;
  description?: string;
  onClose: () => void;
};

const OAuthErrorModal: React.FC<OAuthErrorModalProps> = ({title, description, onClose}) => {
  const {isMobile} = useScreenSize();
  const Modal = isMobile ? DrawerModal : BaseModal;
  const {t} = useTranslation('components', {keyPrefix: 'modals.oauth.oauthErrorModal'});

  return (
    <Modal
      title={<Title>{title ?? t('errorDefault.title')}</Title>}
      tracking={{namespace: 'modals.apps.oauthError'}}
      onClose={onClose}
    >
      <p className="text-sm">{description ?? t('errorDefault.description')}</p>
      <Button
        variant="secondary"
        className="mt-4 w-full"
        onClick={onClose}
        tracking={{namespace: 'modals.apps.oauthError.close'}}
      >
        {t('closeModal')}
      </Button>
    </Modal>
  );
};

export default OAuthErrorModal;
